<td></td>
<td>{{ quantity }}</td>
<td class="expanded-price-cell">
  <lin-form-label [required]="!notEditable">{{ 'BILLING.TRACKERS.' + name | translate }}:</lin-form-label>
  @if (!notEditable) {
  <mat-form-field>
    <div class="input-prepend">
      <span>{{ clientCurrencySymbol }}</span>
      <input matInput type="number" min="0" [(ngModel)]="price" />
    </div>
    <mat-error></mat-error>
  </mat-form-field>
  } @else {
  <div class="text-price"><span>{{ price | platformCurrency }}/mo</span></div>
  }
</td>
<td>{{ quantity * price | platformCurrency }}</td>
